import functions from "./functions.js";

$(function () {

    const $form = $('.newsletter-form');
    const form = $form[0];

    if (!form) {
        return;
    }
    
    $form.on('submit', e => {
        e.preventDefault();

        $('#newsletterModal').modal('show');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['newsletter'] = true;
        params['language'] = functions.getLang();
        params['recaptchaType'] = 'enterprise';

        grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);

                $.post('/services/contact/', params).then(response => {

                    response = JSON.parse(response);
                    $('#newsletterModal').addClass('newsletter-response');
                    $('.newsletter-loading').addClass('d-none');

                    if (response.status == true) {
                        $('.newsletter-success').removeClass('d-none');
                        form.reset();
                    } else {
                        $('.newsletter-error').removeClass('d-none');
                    }
                    
                });
            });
        });

    });

    $('#newsletterModal').on('hidden.bs.modal', e => {
        $('#newsletterModal').removeClass('newsletter-response');
        $('.newsletter-loading').removeClass('d-none');
        $('.newsletter-success').addClass('d-none');
        $('.newsletter-error').addClass('d-none');
    });

});